module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v(_vm._s(_vm.$t("Parrainage")))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('SPONSORSHIP_TEXT'))
    }
  }), _vm._v(" "), _c('v-ons-button', {
    on: {
      "click": _vm.sponsor
    }
  }, [_vm._v(_vm._s(_vm.$t("Formulaire")))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e79c087c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sponsorship.vue
// module id = 239
// module chunks = 0